module.exports = __webpack_public_path__ + "media/images/everfi-background-bottom-1d46910d093475152069e90fd890483a.jpg";